export class BusinessUnit {
  id: string;
  name: string;
  defaultMarketingCampaignId: string | null;

  constructor() {
    this.id = "";
    this.name = "";
    this.defaultMarketingCampaignId = null;
  }
}
